<div [fxLayout]="layout">
    <ng-container *ngFor="let action of completeActions">
        <span [ngStyle]="action.style" matTooltipClass="syntooltip" [matTooltip]="getTooltip(action)">
            <ng-container *ngIf="action.isLink; else isAction">
                <a mat-button
                   target="_blank"
                   [href]="action.route">
                   <mat-icon [svgIcon]="action.icon"></mat-icon>
                   <span class="superscripted-action-title">
                       {{ action.name }}
                       <div *ngIf="action.superscript">{{ action.superscript }}</div>
                   </span>
                </a>
            </ng-container>
            <ng-template #isAction>
                <button mat-button
                    (click)="click(action)"
                    [disabled]="action.disabled"
                    [loading]="action.loading">
                    <mat-icon [svgIcon]="action.icon"></mat-icon>
                    <span> {{action.name}} </span>
                </button>
            </ng-template>
        </span>
    </ng-container>
</div>
